<template>

    <doughnat-chart-card-component
        ref="chart"
        :title="title"
        :url="url"
        :autoload ="autoload"
        :storage-item-name="storageItemName"
        :card-title="title" >

        <div class="mb-3" slot-scope="props">
            <div class="form-inline">

                <div v-if="entities.length > 0">
                    <v-select
                        placeholder="Select Administrative Unit"
                        v-model="props.queryParams.vselect['entity_id']"
                        label="name" value="id"
                        :options="entities"
                        class="m-1" >
                    </v-select>
                </div>

                <v-select
                    placeholder="Select SDG"
                    v-model="props.queryParams.vselect['sdg_id']"
                    label="name" value="id"
                    :options="availableIndicators"
                    class="m-1" >
                </v-select>

                <datepicker ref="year"
                    placeholder="Year"
                    v-model="props.queryParams.datepicker['year']"
                    :bootstrap-styling="true"
                    input-class="form-control"
                    calendar-class="bg-skyblue"
                    wrapper-class="m-1"
                    format="yyyy"
                    minimum-view="year"
                    name="chart-datepicker-from">
                </datepicker>
            </div>

        </div>

    </doughnat-chart-card-component>

</template>

<script>

export default {

    props: {
        title: {
            type: String,
            default: '',
        },

        entityClass: {
            type: String,
            default: 'App\Nation',
        },

        availableIndicators: {
            type: Array,
            default: () => [],
        },

        entities: {
            type: Array,
            default: () => [],
        },

        storageItemName: {
            type: String,
            default: '',
        },

        autoload: {
            type: Boolean,
            default: false,
        },

        urlOverride: {
            type: String,
            default: '',
        }
    },

    data() {

        return {
            APP_URL: window.APP_URL,
        };
    },

    computed: {

        url() {

            if (this.urlOverride !== '') {
                return this.urlOverride;
            }

            else {
                return this.APP_URL + '/sdg/chart?entity_class=' + this.entityClass;
            }
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/indicators/SdgPieChart.vue